/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Request from "../../utils/request";
import utils from "../../utils/utils";
import 'react-lazy-load-image-component/src/effects/opacity.css';
import "./style.less";

const praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png'//选中后
const un_praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/437472759078c049024b762b9f409aad.png'//未点赞
const praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/8a40e7c94f8d375a920c52b5f2ab4207.svga'//点赞动效
const cancel_praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/f83b3847007875c51b0336c78af12616.svga'//取消点赞

class PipelineCommunityArticleScroll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      showAnimated: false,
    };
    this.praiseTimer = null;
    this.isAndroid = utils.isAndroid();
    this.isIphone14ProMax = utils.isIphone14ProMax();
    this.praiseRefMap = {};
    this.praiseImgRefMap = {};
  }

  componentDidMount() {
    this.getCardListData();
    this.peloadingSvg(praised_animated)
  }

  peloadingSvg = (url) => {//预加载图片资源
    if (this.praiseHiddenRef) {
      import('svgaplayerweb').then((SVGA) => {
        const player = new SVGA.Player(this.praiseHiddenRef);
        const parser = new SVGA.Parser(this.praiseHiddenRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(url, (videoItem) => {
          player.loops = 1;
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            player.stopAnimation(true);
            if (url.includes('/8a40e7c94f8d375a920c52b5f2ab4207')) {
              this.peloadingSvg(cancel_praised_animated)
            }
          });
        })
      });
    }
  }

  componentWillUnmount() {
    if (this.praiseTimer) {
      clearTimeout(this.praiseTimer);
      this.praiseTimer = null;
    }
  }

  getCardListData() {
    const itemList = this.props.config.itemList;
    const itemDataObj = {};
    const idList = itemList.map((item) => {
      if (item.id) {
        itemDataObj[item.id] = item;
      }
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    const reqUrl =
      "https://sh-gateway.shihuo.cn/v4/services/sh-gocommunity/x/v1/note/specially-list?test=skip";

    Request({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort: 0,
        page: 1,
        page_size: idList.length,
      },
    }).then((res) => {
      const { status, data } = res.data;
      if (status === 0) {
        const list = data.list || [];
        this.setState({
          list
        })
      }
    });
  }

  showPraiseSvga = (svgaUrl, id) => {
    let praiseRef = this.praiseRefMap[id]
    let praiseIconRef = this.praiseImgRefMap[id]
    if (praiseRef) {
      import('svgaplayerweb').then((SVGA) => {
        console.log('---showPraiseSvga1-', praiseRef, praiseIconRef, praiseRef.clientWidth)
        praiseRef.style.display = "flex";
        praiseIconRef.style.display = "none";
        const player = new SVGA.Player(praiseRef);
        const parser = new SVGA.Parser(praiseRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(svgaUrl, (videoItem) => {
          player.loops = 1;
          
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            praiseRef.style.display = "none";
            praiseIconRef.style.display = "flex";
            player.stopAnimation(true)
          });
        })
      });
    }
  }

  handlePraiseClick(event, id, channel_type, status, item, index) {
    let { list } = this.state;
    event.stopPropagation();
    const reqUrl = "https://sh-gateway.shihuo.cn/v3/apps/app_swoole_common/praise";
    Request({
      url: reqUrl,
      method: "get",
      withCredentials: true,
      params: {
        id,
        channel_type,
        status
      },
    }).then((res) => {
      const { data = {} } = res
      if (data.status == 0) {
        if (item.is_praise) {
          item.is_praise = false;
          item.praise = item.praise - 1;
          item.praise_text = this.formatPraiseNum(item.praise);
          list[index] = item
          this.setState({list})
          this.showPraiseSvga(cancel_praised_animated, id)
          
        } else {
          item.is_praise = true;
          item.praise = item.praise + 1;
          item.praise_text = this.formatPraiseNum(item.praise);
          list[index] = item
          this.setState({list})
          this.showPraiseSvga(praised_animated, id)
        }
      } else if (data.status == 3) {
        window.Jockey.send("action", {
          url: "shihuo://www.shihuo.cn?route=login"
        });
      }
    });
  }

  handleBrowserMoreClick = (url) => {
    // 商品banner跳转
    if (!url) {
      return;
    }
    utils.jumpToUrl(this.props.routeParams, url, url, {}, -1, this.props, {
      bizExtra: {
        model_block: '查看更多'
      }
    });
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;

    const options = {
      title: baseConfig.title,
      sort: index,
    };

    utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, item.id, this.props);
  }

  formatPraiseNum = (praise) => {
    if (typeof praise === 'number' && praise > 9999) {
      praise = parseFloat((praise / 10000).toFixed(1)) + 'w';
    }
    return praise;
  }

  renderCardType1() {
    const { baseConfig = {} } = this.props.config;
    const { list = [], showAnimated } = this.state; 
    return (
      <div className="scroll-type-1">
        <ul>
          {
            list.map((item, index) => {
              return (
                <li
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, {
                    title: baseConfig.title,
                    sort: index,
                  }))}
                  key={`note-${index}`}
                  onClick={() => this.handleItemClick(item, index)}
                >
                  <div className="note-img-wrap">
                    <LazyLoadImage src={utils.formatImgUrl(item.img, this.props.webpSupport)} alt="" className="note-img" effect="opacity" />
                    {
                      item.duration &&
                        <img src="https://static.shihuocdn.cn/admin/files/20240506/37c435801c77b97c25a32861a0e26148.png" alt="" className="video-logo" />
                    }
                  </div>
                  <div className="note-info">
                    <p className="note-title">{item.title}</p>
                    <div className="note-author">
                      <div className="user-info">
                        <div className="avatar-wrap">
                          <LazyLoadImage src={utils.formatImgUrl(item.user_info.avatar, this.props.webpSupport, 'card')} alt="头像" className="avatar" effect="opacity" />
                        </div>
                        <p className={this.isAndroid ? 'username android' : 'username ios'}>{item.user_info.hupu_username}</p>
                      </div>
                      <div className="praise-info" onClick={(event) => this.handlePraiseClick(event, item.id, item.channel_type, item.is_praise ? 2 : 1, item, index)}>
                       
                          <div className='praise-icon-content'>
                              <img
                              className={"praise-icon"}
                              src={item.is_praise ? praised_icon : un_praised_icon}
                              alt=""
                              id={`praise-icon-${item.id}`}
                              ref={r=> {this.praiseImgRefMap[item.id] = r}}
                            />
                            <div
                              className="praise-icon-svga"
                            >
                              <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}} id={`praise-icon-svga-${item.id}`} ref={r=> {this.praiseRefMap[item.id] = r}}/>
                            </div>
                          </div>
                        <p className={this.isAndroid ? 'praise-num android' : 'praise-num ios'}>{item.praise_text || this.formatPraiseNum(item.praise)}</p>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }

  renderCardType2() {
    const { baseConfig = {} } = this.props.config;
    const { mainTitle, subTitle, browserMoreHref, backgroundColor, titleBgColorType, titleBgColor, titleBgColorFrom, titleBgColorTo } = baseConfig;
    const { list = [], showAnimated } = this.state;
    const titleStyle = 
      titleBgColorType == "纯色背景"
      ? { backgroundColor: titleBgColorType == "纯色背景" ? titleBgColor : 'transparent' }
      : { background: titleBgColorType == "渐变色背景" ? `linear-gradient(180deg, ${utils.hexColorToRgba(titleBgColorFrom, 1)} 0%, ${utils.hexColorToRgba(titleBgColorTo, 1)} 100%), #FFFFFF` : 'transparent' }
    return (
      <div className="scroll-type-2" style={{ backgroundColor: backgroundColor || '#FFF' }}>
        <div className="scroll-header" style={titleStyle}>
          <div className="title-area">
            <p className="main-title">{mainTitle}</p>
            <p className="sub-title">{subTitle}</p>
          </div>
          <div className="browser-more" onClick={() => this.handleBrowserMoreClick(browserMoreHref)}>
            <span>更多</span>
            <svg t="1714284720403" className={`icon ${this.isAndroid ? 'android' : 'ios'} ${this.isIphone14ProMax ? 'iphone14promax' : ''}`} viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2761" width="12" height="12"><path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="2762" fill="#333333"></path></svg>
          </div>
        </div>
        <div className="scroll-content">
          <ul>
            {
              list.map((item, index) => {
                return (
                  <li
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, {
                      title: baseConfig.title,
                      sort: index,
                    }))}
                    key={`note-${index}`}
                    onClick={() => this.handleItemClick(item, index)}
                  >
                    <div className="note-img-wrap">
                      <LazyLoadImage src={utils.formatImgUrl(item.img, this.props.webpSupport)} alt="" className="note-img" effect="opacity" />
                      {
                        item.duration &&
                          <img src="https://static.shihuocdn.cn/admin/files/20240506/37c435801c77b97c25a32861a0e26148.png" alt="" className="video-logo" />
                      }
                    </div>
                    <div className="note-info">
                      <p className="note-title">{item.title}</p>
                      <div className="note-author">
                        <div className="user-info">
                          <div className="avatar-wrap">
                            <LazyLoadImage src={utils.formatImgUrl(item.user_info.avatar, this.props.webpSupport, 'card')} alt="头像" className="avatar" effect="opacity" />
                          </div>
                          <p className={this.isAndroid ? 'username android' : 'username ios'}>{item.user_info.hupu_username}</p>
                        </div>
                        <div className="praise-info" onClick={(event) => this.handlePraiseClick(event, item.id, item.channel_type, item.is_praise ? 2 : 1, item, index)}>
                          <div className='praise-icon-content'>
                            <img
                              className={"praise-icon"}
                              src={item.is_praise ? praised_icon : un_praised_icon}
                              alt=""
                              id={`praise-icon-${item.id}`}
                              ref={r=> {this.praiseImgRefMap[item.id] = r}}
                            />
                            <div
                              className="praise-icon-svga"
                            >
                              <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}} id={`praise-icon-svga-${item.id}`} ref={r=> {this.praiseRefMap[item.id] = r}}/>
                            </div>
                          </div>
                          <p className={this.isAndroid ? 'praise-num android' : 'praise-num ios'}>{item.praise_text || this.formatPraiseNum(item.praise)}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    )
  }

  render() {
    const { baseConfig } = this.props.config;
    return (
      <div
        className="pipeline-communityArticleScroll"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px'
        }}
      >
        {
          (!baseConfig.mainTitle && !baseConfig.subTitle)
            ? this.renderCardType1()
            : this.renderCardType2()
        }
        <div style={{ width: 0, height: 0, overflow: 'hidden', position: 'absolute', left: 0, top: 0}} ref={ref => this.praiseHiddenRef = ref} />
      </div>
    );
  }
}

PipelineCommunityArticleScroll.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCommunityArticleScroll };
export default PipelineCommunityArticleScroll;



// WEBPACK FOOTER //
// ./components/pipeline-communityArticleScroll/index.js